import {
  Paragraph,
  SectionType,
  TextRun,
  TabStopType,
  TabStopPosition,
  Tab,
  HeadingLevel,
  ISectionOptions,
} from 'docx'
import highlights from '../common/highlights'
import dateRange from '../common/dateRange'
import { Resume } from '@/types/resume/v1'

const projects = ({ projects }: Resume.Schema): ISectionOptions => {
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'Projects',
        heading: HeadingLevel.HEADING_2,
      }),
      ...projects.reduce<Paragraph[]>((acc, workItem) => {
        return acc.concat(createProjectItem(workItem))
      }, []),
    ],
  }
}

const createProjectItem = (project: Resume.Project): Paragraph[] => {
  const item: Paragraph[] = []
  item.push(
    new Paragraph({
      text: '\n',
    })
  )
  item.push(
    new Paragraph({
      children: [
        new TextRun({
          text: project.name,
          bold: true,
        }),
        new TextRun({
          children: [new Tab()],
        }),
        new TextRun({
          text: dateRange(project.startDate, project.endDate, true),
        }),
      ],
      tabStops: [
        {
          type: TabStopType.RIGHT,
          position: TabStopPosition.MAX,
        },
      ],
    })
  )
  if (project.description) {
    item.push(
      new Paragraph({
        text: '\n',
      })
    )
    item.push(
      new Paragraph({
        text: project.description,
      })
    )
  }
  item.push(...highlights(project.highlights))
  return item
}

export default projects
